// Input only type ...
export enum TagGroupAutoHandleConflictsGq {
  NONE = 'NONE',
  FIRST_OCCURANCE = 'FIRST_OCCURANCE'
}
